import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { IonContent, IonHeader, IonIcon, IonLabel, IonSegment, IonSegmentButton, IonTitle, IonToolbar, ModalController } from '@ionic/angular/standalone';
import { SexyModule } from '@qid/sexy';
import { SuperButtonComponent } from '@qid/super';
import { FeatureKeys } from "../../enum/feature-keys.enum";
import { TimePeriod } from '../../enum/time-period.enum';
import { CheckoutComponent } from "../../modules/order";
import { Plan, PlanService } from "../../modules/plan";
import { PlanStatus } from '../../modules/plan/lib/enum/plan-status.enum';
import { PlanVisibility } from '../../modules/plan/lib/enum/plan-visibility.enum';

@Component({
  selector: 'oneqid-nx-upgrade-plan',
  templateUrl: './upgrade-plan.page.html',
  styleUrls: ['./upgrade-plan.page.scss'],
  standalone: true,
  imports: [
    FormsModule,
    SexyModule,
    SuperButtonComponent,
    CheckoutComponent,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonSegment,
    IonSegmentButton,
    IonLabel,
    IonIcon
  ],
})
export class UpgradePlanPage {

  public plans: Plan[] = [];

  public selectedPlan: Plan = null;
  public isPaymentProcessing = false;
  public paymentTerms: TimePeriod = TimePeriod.YEARLY;
  public annualDiscount = 20;

  protected readonly FeatureKeys = FeatureKeys;
  protected readonly TimePeriod = TimePeriod;

  constructor(private planService: PlanService,
    private router: Router,
    private modalController: ModalController
  ) {
  }


  ionViewDidEnter() {
    this.fetchPlans()
  }

  async fetchPlans() {
    const res = await this.planService.readAllPublic()

    if (res?.data) {

      const filteredPlans = res.data.filter(plan =>
        plan.visibility == PlanVisibility.public &&
        plan.status == PlanStatus.published);


      this.plans = filteredPlans
      this.sortPlansByPrice()
    }
  }


  getPrice(plan: Plan) {

    const pricingModel = plan.planPricingModels.find(pricingModel => pricingModel.name.toLowerCase() == this.paymentTerms.toLowerCase());

    if (!pricingModel) {
      return 0;
    }

    const price = pricingModel.amount;
    const discountAmount = pricingModel.discountAmount;
    let finalPrice = price - discountAmount;



    if (this.paymentTerms == TimePeriod.YEARLY) {
      finalPrice = finalPrice / 12;
    }

    return finalPrice.toFixed(0);
  }

  getPriceForSorting(plan: Plan): number {
    const pricingModel = plan.planPricingModels.find(pricingModel => pricingModel.name.toLowerCase() == this.paymentTerms.toLowerCase());

    if (!pricingModel) {
      return 0; // Return 0 if no pricing model found for the current payment terms
    }

    const price = pricingModel.amount;
    const discountAmount = pricingModel.discountAmount;
    let finalPrice = price - discountAmount;

    if (this.paymentTerms == TimePeriod.YEARLY) {
      finalPrice = finalPrice / 12;
    }

    return finalPrice;
  }


  sortPlansByPrice() {
    this.plans.sort((a, b) => {
      const priceA = this.getPriceForSorting(a);
      const priceB = this.getPriceForSorting(b);
      return priceA - priceB;
    });
  }

  onChoosePlanClicked = (plan: Plan) => {
    this.selectedPlan = plan;
  }

  onCheckoutSuccess = async () => {
    window.location.reload();
  }


  getFeatureQuota(featureKeyName: string, plan: Plan) {
    const featureQuota = plan.planFeatureQuota.find(featureQuota => featureQuota.featureKeyName == featureKeyName);
    return featureQuota?.quota;
  }

  onBackClicked = () => {

    if (this.selectedPlan != null) {
      this.selectedPlan = null;
      return;
    }

    if (this.modalController) {
      this.modalController.dismiss();
    }
  }


}
